import { render } from "./PopularServicesSection.vue?vue&type=template&id=2a3810ff&scoped=true"
import script from "./PopularServicesSection.vue?vue&type=script&lang=js"
export * from "./PopularServicesSection.vue?vue&type=script&lang=js"

import "./PopularServicesSection.vue?vue&type=style&index=0&id=2a3810ff&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3810ff"]])

export default __exports__